// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/BrandReliability/brandReliability.scss
// module id = 1411
// module chunks = 10